import { Pipe, PipeTransform, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@Pipe({
    name: 'floor'
})
export class FloorPipe implements PipeTransform {
    transform(value: number): number {
        return Math.floor(value);
    }
}

@NgModule({
    imports: [CommonModule],
    declarations: [FloorPipe],
    exports: [FloorPipe]
})
export class FloorPipeModule {}
